import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { auth } from './auth';
import loading from './loading';
import { app } from './app';
import consultaDeLiquidacion from './consultaDeLiquidacion';
import recetaDigital from './recetaDigital';
import tramitesAutorizaciones from './tramitesAutorizaciones';
import altaDeAutorizaciones from './altaDeAutorizaciones';
import conectividad from './conectividad';
import datosPersonales from './datosPersonales';
import { infoSwiss } from './infoSwiss';
import consultaDeLiquidacionConTramites from './consultaDeLiquidacionConTramites';
import messages from './messages';
import calificaciones from './calificaciones';
import consultaDePagosYFacturas from './consultaDePagosYFacturas';
import { branches } from './branches';
import { revistaAequalis } from './revistaAequalis';
import capweb from './capweb';
import capwebADP from './capwebADP';
import pagos from './pagos';
import facturas from './facturas';
import { manageUsers } from './manageUsers';

export default combineReducers({
  form: formReducer,
  app,
  auth,
  capweb,
  capwebADP,
  branches,
  revistaAequalis,
  infoSwiss,
  loading,
  consultaDePagosYFacturas,
  consultaDeLiquidacion,
  recetaDigital,
  tramitesAutorizaciones,
  altaDeAutorizaciones,
  conectividad,
  datosPersonales,
  consultaDeLiquidacionConTramites,
  messages,
  calificaciones,
  manageUsers,
  pagos,
  facturas,
});
